import { EuiButtonIcon, EuiFlexItem, EuiRange, EuiText } from '@elastic/eui';
import React, { useCallback, useMemo } from 'react';
import { stringToFloat } from '../../../../../shared/utils/numbers';

export const ItemInfoCPUser = (props) =>{

    const {data, onChange, error, readOnly, handleDelete} = props;

    const onChangeValue = (porcentaje) =>{
        const newData = {...data, ...{porcentaje:stringToFloat(porcentaje)}}
        onChange && onChange(newData)
    }

    const isReadOnly = useMemo(() =>{
        return readOnly!==undefined && readOnly 
    },[readOnly])

    const isDeleteable = useMemo(() => data.isDeleteable,[data])

    const onDelete = useCallback(() =>{
        if(!isReadOnly && isDeleteable){
            handleDelete(data.idCP)
        }
    },[isReadOnly,isDeleteable,data,handleDelete])

    const btnDelete = useMemo(()=> !isReadOnly ? 
    (<EuiFlexItem grow={false}>
        <EuiButtonIcon isDisabled={!isDeleteable} onClick={()=>onDelete()} iconSize='m' iconType={'trash'} color={'danger'}/>
    </EuiFlexItem>) 
    : null, [isReadOnly,onDelete])

    return(
        <>
        {btnDelete}
         <EuiFlexItem grow={false}><EuiText className='item-text-cp'>{`CP ${data.idCP}`}</EuiText></EuiFlexItem>
            <EuiFlexItem grow={8}>
                <EuiRange
                className={`rangeCPUser${error===true?'-error':''}`}
                id={data.IdCP}
                readOnly={isReadOnly}
                fullWidth
                compressed
                min={0}
                max={100}
                value={data.porcentaje}
                onChange={(e)=>onChangeValue(e.target.value)}
                showInput
                showRange
                showTicks
                tickInterval={10}
                aria-label="An example of EuiRange with custom tickInterval"
            />
        </EuiFlexItem>
        </>
    )
}